const remote = {
    apiURL: "https://api.flio.com"
}

const local = {
    apiURL: "http://localhost:3000"
}

export default local;
